import React from 'react';
import type { SpaceProps } from 'styled-system';

import { useLocalization } from '../../../providers/LocaleProvider';
import { Flex } from '../../Flex';
import Star from '../../Rating/Star';
import { CaptionRegularCR2 } from '../../Typography';

const SINGLE_STAR_SIZE = 14;
const RATING_TEXT_COLOR = 'sys.neutral.text.default';

interface RatingProps extends SpaceProps {
  average: number;
  count: number;
}

const Rating = ({ average, count, ...spaceProps }: RatingProps) => {
  const { r, formatNumber } = useLocalization();

  return (
    <Flex alignItems="center" data-testid="rating" {...spaceProps}>
      <Flex alignItems="center" width="fit-content" justifyContent="center">
        <Star display="flex" alignItems="center" isFull size={SINGLE_STAR_SIZE} />
      </Flex>
      <CaptionRegularCR2 as="span" data-testid="rating-counter" color={RATING_TEXT_COLOR}>
        {r.t('h24_plp_card_rating_distribution', { count: formatNumber(average, 1), total: count })}
      </CaptionRegularCR2>
    </Flex>
  );
};

export default Rating;
